import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const CreateWAGroupModal = React.lazy(() => import("./create-wa-group.modal"));

const CreateWAGroup: iModalProps<typeof CreateWAGroupModal> = {
  name: "create-wa-group",
  component: GenerateModalWithSuspense(CreateWAGroupModal),
};

export default CreateWAGroup;
